import { render, staticRenderFns } from "./FileTemplate.vue?vue&type=template&id=c3cf76a2&scoped=true"
import script from "./FileTemplate.vue?vue&type=script&lang=js"
export * from "./FileTemplate.vue?vue&type=script&lang=js"
import style0 from "./FileTemplate.vue?vue&type=style&index=0&id=c3cf76a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cf76a2",
  null
  
)

export default component.exports